/**
 * trade
 * 支付API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import NodeDto from '../../room/model/NodeDto';
import UseHistoryDto from '../../room/model/UseHistoryDto';
  /**
   * Room service.
   * @module room/api/RoomApi
   * @version 0.2.0
   */

  /**
   * Constructs a new RoomApi. 
   * @alias module:room/api/RoomApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 获取寝室列表
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:room/model/NodeDto>}
     */
    this.findAll = function() {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [NodeDto];

      return this.apiClient.callApi(
        '/api/room/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, false
      );
    }


    /**
     * 获取寝室列表
     * @param {Integer} id 寝室id
     * @param {Date} month 月份
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:room/model/UseHistoryDto>}
     */
    this.useHistory = function(id, month) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling useHistory";
      }

      // verify the required parameter 'month' is set
      if (month == undefined || month == null) {
        throw "Missing the required parameter 'month' when calling useHistory";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
        'month': month
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [UseHistoryDto];

      return this.apiClient.callApi(
        '/api/room/{id}/use_history', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, false
      );
    }
  };

  export default exports;
